// ─── Dispatcher Endpoints ─────────────────────────────────────────────────────

export const API_ADD_DISPATCHER = '/dispatcher/register';
export const API_GET_DISPATCHER = '/dispatcher/dispatcherById/';
export const API_EDIT_DISPATCHER = '/dispatcher/updateprofile';
export const API_GET_DISPATCHERS_URL = '/dispatcher/';
export const API_DELETE_DISPATCHER = '/dispatcher/remove';
